import { gql } from "@apollo/client";

import { scenarioVersionWithRulesFragment } from "src/graphql/anti-fraud/fragments/ScenarioVersionFragment";
import { shortScenarioFragment } from "src/graphql/anti-fraud/fragments/ShortScenarioFragment.ts";

export const fullScenarioFragment = gql`
  fragment FullScenarioFragment on Scenario {
    ...ShortScenarioFragment
    draftVersion {
      ...ScenarioVersionWithRulesFragment
    }
    archivedVersions {
      ...ScenarioVersionWithRulesFragment
    }
  }

  ${scenarioVersionWithRulesFragment}
  ${shortScenarioFragment}
`;
